








































































import { Component, Vue, Provide ,Prop,Watch} from "vue-property-decorator";
import {  timeFormat ,jsIntString } from "@/utils";
import { GenderEnum } from "@/enum/index";
import dataCenter from '@/request/requestIndex/index';
import ElImageViewer from "element-ui/packages/image/src/image-viewer.vue";

const deleteDialog = () => import("@/views/peopleManagement/components/deleteDialog.vue");
@Component({
    name: "identity",
    components: { deleteDialog ,ElImageViewer }
})
export default class CombinationProperty extends Vue {
    @Prop() baseUserInfo: any;
    @Prop() identityAdd: any;
    @Prop() identityDetail: any;
    @Prop() detailInfo: any;
    @Prop() identityLoading: any;

    @Provide() private dialogVisible: Boolean = false;
    @Provide() private detailForm: any = {};
    @Provide() private url: any = '';
    @Provide() private imgShow: Boolean = false;
    @Provide() private type: any = 'add';
    @Provide() private imgPreviewList:any = [];
    @Provide() private showImgViewer:Boolean = false;
    @Provide() private btnType: string = 'primary';
    @Provide() private btnClick: Boolean = false;


    // 身份信息
    @Provide() private idCardForm: any = {
        identity: '',
        rfc:'',
        curp:'',
        identityphoto: '',
        panelstatus:0,
        fileList: []
    };
    @Provide() private rules: any =  {
        // identity: [
        //     { required: true, message: 'please enter', trigger: 'change' },
        // ],
        curp: [
            { required: true, message: 'please enter', trigger: 'change' },
        ]
    };

    @Watch("detailInfo")
    onDetailInfoChanged(val: any) {
        if (val) {
            this.detailInfo.identity.identityphoto == 0 ? this.detailInfo.identity.identityphoto = '' : this.detailInfo.identity.identityphoto
           
            this.detailForm = JSON.parse(JSON.stringify(this.detailInfo.identity))
            this.idCardForm = JSON.parse(JSON.stringify(this.detailInfo.identity))
            if(this.imgShow && this.idCardForm.identityphoto){
                this.previewImg(this.idCardForm.identityphoto,'edit')
            }

            this.$emit('initForm',this.idCardForm,'2')
        }
    }
    private created () {
        this.$emit('initForm',this.idCardForm,'2')
    }
    // submit
    private submitForm(formName:string){
        let ref: any = this.$refs[formName];
        ref.validate((valid:any) => {
            if (valid) {
                // if(this.idCardForm.fileList && this.idCardForm.fileList.length > 0 && this.idCardForm.fileList[0].url){
                    this.idCardForm.panelstatus = 0
                    this.$emit('submitForm',this.idCardForm,'2')
                // }else{
                //     this.$message({
                //         type: "error",
                //         message: "please upload"
                //     });
                // }
            } else {
                return false;
            }
        });
    }
    // reset
    private  resetForm(formName:string) {
        let ref: any = this.$refs[formName];
        ref.resetFields();
        this.$emit('resetForm','2')
    }
    //show add
    private addInfo () {
        this.type = 'add'
        this.idCardForm.fileList = []
        this.$emit('addForm','2')
    }
    // edit
    private editInfo () {
        this.type = 'edit'
        this.idCardForm = JSON.parse(JSON.stringify(this.detailInfo.identity))
        if(this.idCardForm.identityphoto == '' || this.idCardForm.identityphoto == 0){
            this.idCardForm.fileList = [] 
        }else{
            this.previewImg(this.idCardForm.identityphoto,'edit')
        }
        this.$emit('editForm','2')
    }
    private deleteInfo () {
        //弹框提示是否删除
        this.dialogVisible = true
    }
    private cancelConfirm () {
        this.dialogVisible = false
    }
    private deleteConfirm () {
        this.dialogVisible = false
        this.$emit('deleteForm','2')
    }
    
    private onExceed() {
        this.$message({
            type: "error",
            message: "should be less than 1 files."
        });
    }

    private photoChange(val: any, list:[]) {
        let that = this;
        that.btnClick = true
        that.btnType = 'info'
        let reg = /png|jpg|jpeg/g;
        if(/png|jpg|jpeg/g.test(val.raw.type) && val.raw.size <= 500000) {
            let reader:any = new FileReader();
            reader.readAsArrayBuffer(val.raw);
            reader.onload = function () {
                let file = new Uint8Array(this.result);
                dataCenter.commonApi.peopleManagementImg({
                    setRelatedid: that.baseUserInfo.id,
                    setContenttype: val.raw.type,
                    setExten: (val.raw.name.match(/\.[a-zA-Z]+$/g))[0],
                    setData: file,
                    setUsemark:1
                }).then((res: any)=> {
                    //记录当前上传的id  
                    that.idCardForm['identityphoto'] = res.resourceid
                    that.idCardForm.fileList = list;
                    that.btnClick = false
                    that.btnType = 'primary'
                },(oError:any)=> {
                    that.btnClick = false
                    that.btnType = 'primary'
                    that.idCardForm.fileList = [];
                })
            }
        }else {
            that.btnClick = false
            that.btnType = 'primary'
            that.idCardForm.fileList = [];
            that.detailForm.fileList = [];
            that.$message({
                type: "error",
                message: "jpg/png only,less than 500k"
            });
        }
    }

    private async previewImg(id:any,type:any) {
        const { downloadDocumentReq }: any = await import("@/request/peopleManagement");
        let _arg = {resourceid: String(id),usermark:1};
        let res = await downloadDocumentReq(_arg);
        if (res && res.right) {
            this.url ="data:" + res.mediaheader + ";base64," + res.mediabody;
            if(type === 'edit'){
                //点击编辑，反显照片
                let obj = {
                    url:this.url
                }
                this.idCardForm.fileList = []
                this.idCardForm['fileList'].push(obj)
                this.$forceUpdate()
            }else{
                this.imgShow = true
            }
        }
    }

    // 打开图片查看器
    private openImgViewer(file:any) {
        // 获取要查看的图片临时地址
        this.imgPreviewList = [file.url];
        // 显示图片查看器
        this.showImgViewer = true;
    }

    // 关闭图片查看器
    private closeImgViewer() {
        this.showImgViewer = false;
    }

    private handleRemove (file:any,fileList:any) {
        this.idCardForm.fileList = []
        this.detailForm.fileList = []
        this.idCardForm.identityphoto = ''
        this.idCardForm.identityphoto = ''
    }
}
